import i18next from "i18next";

export function formatDate(isoString: string): string {
  return i18next.t("intlDateTime", {
    val: new Date(isoString),
    formatParams: {
      val: { year: "numeric", month: "long", day: "numeric" },
    },
  });
}
